import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { prettyDate, prettyFloatMoney } from '@/helpers/utils';
import { Preloader } from '@/components/Preloader';
import { EmptyContent } from '@/components/TaxReport/EmptyContent';
import { DATE_FORMAT_DD_MM_YYYY } from '@/helpers/common';
import { useDownloadLink } from '@/hooks/useDownloadLink';
import { MyTooltip } from '@/webkit/MyTooltip';
import IconFile from './icon_file.svg';
import s from './index.module.scss';

export const Table = ({ data, isLoading }) => {
  const { t } = useTranslation('reports');
  const [loading, setLoading] = useState(false);
  const { onDownload } = useDownloadLink();

  const handleDownload = async data => {
    try {
      setLoading(true);
      await onDownload({
        url: data.invoice_link,
        filename: ['Cash-movements', data.description, data.created_at].join(
          '-',
        ),
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={s.table_wrapper}>
      <div className={s.table_inner}>
        <div className={s.table}>
          <div className={s.table__thead}>
            <div className={s.table__thead_col}>{t('cash_data.date')}</div>
            <div className={s.table__thead_col}>{t('cash_data.type')}</div>
            <div className={s.table__thead_col}>
              {t('cash_data.description')}
            </div>
            <div className={s.table__thead_col}>{t('cash_data.amount')}</div>
            <div className={s.table__thead_col}>{t('cash_data.balance')}</div>
          </div>

          {isLoading ? (
            <Preloader className={s.preloader} />
          ) : data?.total_count > 0 ? (
            <div className={s.table__tbody}>
              {data.list.map((item, index) => (
                <div key={index} className={s.table__tbody_row}>
                  <div className={s.table__tbody_col}>
                    {prettyDate(item.created_at, DATE_FORMAT_DD_MM_YYYY)}
                  </div>
                  <div
                    className={s.table__tbody_col}
                    title={item.operation_type}
                  >
                    <span>{item.operation_type}</span>
                  </div>
                  <div className={s.table__tbody_col} title={item.description}>
                    <span>{item.description}</span>
                  </div>
                  <div className={s.table__tbody_col}>
                    <span
                      style={{ color: item.amount > 0 ? '#499E1F' : '#E32144' }}
                    >
                      {`${item.amount > 0 ? '+' : ''}${prettyFloatMoney(
                        item.amount,
                        {
                          decimalPlaces: 2,
                        },
                      )}`}
                    </span>
                  </div>
                  <div className={s.table__tbody_col}>
                    <span>
                      {prettyFloatMoney(item.balance, {
                        decimalPlaces: 2,
                      })}
                    </span>
                  </div>
                  <div className={s.table__tbody_col}>
                    {item.invoice_link && (
                      <MyTooltip
                        theme="dark"
                        placement="top"
                        renderElement={() => (
                          <button
                            type="button"
                            disabled={loading}
                            className={s.btn_download}
                            onClick={() => handleDownload(item)}
                          >
                            <img
                              src={IconFile}
                              alt="file"
                              width={20}
                              height={20}
                            />
                          </button>
                        )}
                        renderContent={() => (
                          <div style={{ padding: '8px' }}>
                            {t('cash_data.download_invoice')}
                          </div>
                        )}
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className={s.empty}>
              <EmptyContent />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
